import React from "react";
import styled from "@emotion/styled";
import PopupFull from "components/Common/PC/PopupFull";
import GuaranteeTable from "components/Travel/PC/GuaranteeTable";
import { ageRange } from "discription";
import icon1 from "images/pc/icon-intro1.svg";
import icon2 from "images/pc/icon-intro2.svg";
import icon3 from "images/pc/icon-intro3.svg";
import icon4 from "images/pc/icon-intro4.svg";

interface Props {
  onOk: any;
}

const GuidePopup: React.FC<Props> = ({ onOk }) => (
  <PopupFull
    title="Chubb 해외여행보험"
    onOk={onOk}
    isLarge={true}
    coveredStyle={true}
  >
    <GuideContent>
      <header className="guideHeader">
        <h1 className="title">
          <span className="small">후회없는 여행을 위한 노하우</span>
          Chubb 해외여행보험
        </h1>
        <p className="permission">손해보험협회 심의필 제19517호(2019.07.29)</p>
      </header>
      <div className="guideBody">
        <ul className="strongList">
          <li>
            <span className="icon">
              <img src={icon1} alt="" />
            </span>
            <p className="desc">
              <strong>여행지에서 아파도 든든하게</strong>
              여행이 시작되는 순간부터 끝나는 순간까지 예기치 못한 질병이나,
              상해사고가 발생해도 병원비 걱정없이 든든하게 보장해드립니다.
              (특약가입 시)
            </p>
          </li>
          <li>
            <span className="icon">
              <img src={icon2} alt="" />
            </span>
            <p className="desc">
              <strong>다른 사람에게 손해를 입혀도</strong>
              예기치 못한 사고로 다른 사람의 신체나 재산에 대한 피해를 입힌
              경우, 가입금액 내 본인부담금(1만원) 공제 후 보상합니다. (특약가입
              시)
            </p>
          </li>
          <li>
            <span className="icon">
              <img src={icon3} alt="" />
            </span>
            <p className="desc">
              <strong>소지품 도난, 파손되더라도 문제없이</strong>
              아끼는 물건이 도난 당하거나, 파손되더라도 가입금약 내
              본인부담금(1만원) 공제 후 보상하며 여권 재발행 비용까지
              보상합니다. (특약가입 시)
            </p>
          </li>
          <li>
            <span className="icon">
              <img src={icon4} alt="" />
            </span>
            <p className="desc">
              <strong>24시간 한국어 안내 콜센터 운영</strong>
              여행지에서 긴급상황 발생 시 24시간 한국어 안내가 지원되는 Chubb
              Assitance 긴급지원 서비스 센터 82-2-3449-3500로 연락주시면
              의사/병원안내, 긴급의료이송, 귀국수배, 유해본국송환 서비스등을
              도와드립니다.
            </p>
          </li>
        </ul>

        <h2 className="title">보장내용</h2>
        <p className="titleDesc">15-70세 기준</p>
        <GuaranteeTable contents={ageRange[1].general} />
      </div>
    </GuideContent>
  </PopupFull>
);

export default GuidePopup;

const GuideContent = styled.div`
  line-height: 1.5;

  .guideHeader {
    display: flex;
    justify-content: space-between;
    border-top-left-radius: ${props => props.theme.radius};
    border-top-right-radius: ${props => props.theme.radius};
    padding: 36px 50px 30px;
    background-color: ${props => props.theme.colors.primary};
    color: ${props => props.theme.colors.white};
  }

  .title {
    font-size: ${props => props.theme.guidePopup.sizeTitle};
    font-weight: ${props => props.theme.weight.extraBold};

    .small {
      display: block;
      font-size: ${props => props.theme.text.sizeFontM};
      font-weight: ${props => props.theme.weight.normal};
    }
  }

  .permission {
    color: ${props => props.theme.white};
  }

  .guideBody {
    padding: 61px 50px 0;
    color: ${props => props.theme.colors.text};

    .title {
      font-size: ${props => props.theme.text.sizeFontL};
    }

    .titleDesc {
      margin-bottom: 19px;
      color: ${props => props.theme.colors.textSub};
    }
  }

  .strongList {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding-bottom: 38px;

    > li {
      display: flex;
      margin-bottom: 20px;
      max-width: 367px;

      &:nth-of-type(2n) {
        margin-left: 60px;
      }

      @media (max-width: 900px) {
        max-width: 100%;
        min-height: 60px;

        &:nth-of-type(2n) {
          margin-left: 0;
        }

        .desc {
          max-width: 100%;
        }
      }
    }

    .desc {
      margin-left: 13px;
      max-width: 314px;

      strong {
        display: block;
        margin-bottom: 3px;
        font-weight: ${props => props.theme.weight.bold};
        font-size: ${props => props.theme.text.sizeFontM};
      }
    }
  }
`;
